import React from 'react';
import { TableReprocessing } from '../../components';
import RowHeaderHelp from '../../components/RowHeaderHelp';


const Reprocessing: React.FC = () => {
  return (
    <div className="container-body no-padding">
      <RowHeaderHelp name="Reprocessamento" />
      <TableReprocessing />
    </div>
  );
};

export default Reprocessing;
